import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";

import { ApiService } from './api.service';
import { ModelFactory } from '../models/model.factory';
import { Models } from "../models";
import 'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";

@Injectable()
export class BackendService {


    protected model;

    constructor(protected api: ApiService) {
    }

    // set model
    setModel(model) {
        this.model = model;
    }

    find(id) {
        return this.api.get(new this.model().getUri() + '/' + id).map(client => {
            client.data = ModelFactory.make(Models.get(this.model.key), client.data);
            return client;
        });
    }

    save(data) {
        if(data[data.getKey()]) {
            return this.update(data);
        }
        return this.createNew(data);
    }

    update(data) {
        let payload = data.serialize();
        return this.api.put(data.getUri() + '/' + data[data.getKey()], payload);
    }

    createNew(data) {
        let payload = data.serialize();
        return this.api.post(data.getUri(), payload);
    }

    destroy(data) {
        return this.api.delete(data.getUri() + '/' + data[data.getKey()]);
    }

    get(model = null, options: any = { page: 1 }) {


        let requestOptions: any = {
            params: new HttpParams()
        };

        if(options.page != 1) {
            requestOptions.params = new HttpParams().set('page', String(options.page));
        }

        let observable;

        if(model === null) {
            observable = this.api.get(new this.model().getUri(), requestOptions);
        } else {
            observable = this.api.get(model.getUri(), requestOptions);
        }

        observable = observable.map(response => {
            let data = response.data;
            response.data = ModelFactory.makeFromArray(Models.get(this.model.key), data);
            return response;
        });

        return observable;
    }

    getRelated(related, key, model = null, options = {}) {
        if(model == null) {
            model = this.model;
        }

        let constructor = Models.get(model.key);
        model = ModelFactory.makeRelated(new constructor(), related, key);

        return this.get(model);
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/http/backend.service.ts